import React from 'react';
// import PageInfoStore from './flux/PageInfoStore';
// import MainSubNav from './MainSubNav';
// import MainNavButtons from './MainNavButtons';

export default function Video(props) {
  const media = props.media;
  console.log(media);

  function renderSource(source) {
    // console.log(source);
    return (
      <source
        src={source.url}
        type={source.mime_type}
      />
    )
  }
  
  return (
    <video
      playsinline="playsinline" 
      controls="controls"
      autoplay="autoplay"
      preload="none"
      mute="false"
      loop="false"
    >
      {media.sources.map((source) => { return renderSource(source) })}
      <img src={media.src} />
    </video>
  );
}